import React, { useState,useContext,useEffect } from 'react';
import { ModalContainer,UIcon,IconContainer ,
    MainContentContainer1,SubmitContainer,
    StyleButton,StyleInput,StyleLabel
} from '../Modal/CreateAdminUser';
import { FilterDropDown, option1b } from '../../../../ui-components';
import { useSettingModal } from '../../../../hooks/Context';
import { FetchSingleData } from '../../../../hooks/FetchData';
import apiCall from '../../../../utils/apiCall';
import apiCallFormData from '../../../../utils/apiFormDataCall';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from '../../../../providers/notification';
import { string } from 'yup';

interface ComponentProps {
  Id:number;
  IsSubmitted:boolean;
  ActiveStatus:boolean;
  ClassyTypeId: number;
  SectorType:string;
  ClassificationType:string;
  AnnualSubscription:number;
}

interface ClassificationType{
  name:string;
  val:number;
}

const options = [
  {name:'A',val:1},
  {name:'B',val:2},
  {name:'C',val:3},
  {name:'D',val:4},
  {name:'E',val:5},
  {name:'F',val:6},
  
]

const options1b = [
  {name:'Public', val:1},
  {name:'Private', val:2},  
]


const CreateCompanyClass= (props:ComponentProps) => {  
    const [ClassificationType, setClassificationType] = useState<ClassificationType>(options[0]);
    const [sectorType, setSectorType] = useState<ClassificationType>(option1b[0]);
    const [AnnualSubscription, setAnnualSubscription] = useState<any>(props.AnnualSubscription || 0);
    const [loading, setLoading] = useState<boolean>(false);
  
    const {showNotification } = useContext(NotificationContext);
    const {setShowModal} = useSettingModal();
    const queryClient = useQueryClient()

    const handleCreateCompany= async() =>{
        const data = new FormData();
          
          data.append('ClassificationType', ClassificationType.name);
          data.append('SectorType',sectorType.name);
          data.append('AnnualSubscription', AnnualSubscription);
          data.append('IsSubmitted',props?.IsSubmitted.toString() || 'true');
          data.append('ActiveStatus',props?.ActiveStatus.toString() || 'true');
          if(props.Id){
            data.append('ClassyTypeId',props.ClassyTypeId.toString());
            data.append('ApplicantId',props.Id.toString());
          }
          
      
        setLoading(true);
        return  await ( !props.Id? await apiCallFormData().post('/SetUp/CreateClassification', data):
        await apiCallFormData().put('/SetUp/UpdateClassification?Id='+props.Id, data)).data;
    }
    const AddCompanyClassMutation = useMutation(handleCreateCompany,{

      onSuccess:()=>{
        showNotification({
          type:'success',
          message: !props.Id?'Classification Successfully Created':'Classifcation Updated successfully',
        })
        setShowModal(false);
        setLoading(false);
        queryClient.invalidateQueries(['get-all-classification']);
      },
     
      onError(error:any, variables, context) {
        setShowModal(false);
        showNotification({
          type:'error',
          message: error.Message || 'Classification cannot be Updated',
        })
        setLoading(false);
      },

      
    })

    const handleForm = (e:any) =>{
      e.preventDefault();
      if (ClassificationType?.name.length === 0) {
        showNotification({
          type: 'error',
          message: 'Classification type is required'
        })
        return;
      }

      if (sectorType?.name.length === 0) {
        showNotification({
          type: 'error',
          message: 'Sector type is required'
        })
        return;
      }

      if(AnnualSubscription === 0) {
        showNotification({
          type: 'error',
          message: 'Annual subscription is required'
        })
        return;
      }

      if(ClassificationType.val && sectorType.val && AnnualSubscription){
        AddCompanyClassMutation.mutate();
      }
    }

  useEffect(()=>{
    if(props && props.Id){
      let sector = options1b.find(eSector => eSector.name.toLowerCase().includes(props.SectorType.toLowerCase()));
      setSectorType(sector|| options1b[0]);

      let classification = options.find(eClass => eClass.name.toLowerCase().includes(props.ClassificationType.toLowerCase()));
      setClassificationType(classification|| options[0]);
      setAnnualSubscription(props.AnnualSubscription);
    }
  },[props.Id])

  return (
    <ModalContainer>
    <div>
      <div>
        <div>
          <IconContainer><UIcon /></IconContainer>
          <span>{props.Id?'Update Classification':'Create Classification'}</span>
        </div>
      </div>
      <MainContentContainer1 onSubmit={handleForm}>
        <StyleLabel style={{width:'100%'}}>
            <span>Classification</span>
            <FilterDropDown onChange={setClassificationType} replace='true' options={options} text={props.ClassificationType?props.ClassificationType:'Select Classification'} border="1px solid lightgray" bg='white' />

        </StyleLabel>
        {/* <StyleLabel>
            <span>Classification</span>
            <StyleInput onChange={(e:any)=>setClassification(e.target.value)} placeholder='Classification' />
        </StyleLabel> */}
        {/* <StyleLabel>
            <span>Sector</span>
            <StyleInput onChange={(e:any)=>setSector(e.target.value)} placeholder='Sector' />
        </StyleLabel> */}
        <StyleLabel style={{width:'40%'}}>
            <span>Sector</span>
            <FilterDropDown replace='true' onChange={setSectorType} options={options1b} text={props.SectorType?props.SectorType:'Select Sector'} border="1px solid lightgray" bg='white' />

        </StyleLabel>
        <StyleLabel>
            <span>Annual subscription</span>
            <StyleInput type="number" value={AnnualSubscription}  onChange={(e:any)=>setAnnualSubscription(e.target.value)} required={true} />
        </StyleLabel>
        <SubmitContainer>
            <span onClick={()=>setShowModal(false)}>Cancel</span>
            <StyleButton >
                {!loading ?'Submit':'Loading...'}
            </StyleButton>
        </SubmitContainer>

      </MainContentContainer1>
      </div>
    </ModalContainer>
  )
}

export default CreateCompanyClass